import { useRef, useState } from "react";
import { DatabaseBackup, Download, Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";

export default function BackupCard({ canImport = true }) {
  const [exporting, setExporting] = useState(false);
  const [importing, setImporting] = useState(false);
  const fileRef = useRef(null);

  const exportBackup = async () => {
    setExporting(true);
    try {
      const res = await api.get("/backup/export", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `usta-hesap-yedek-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 10000);
      toast.success("Yedek dosyası indirildi");
    } catch {
      toast.error("Yedek alınamadı");
    } finally {
      setExporting(false);
    }
  };

  const importBackup = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setImporting(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/backup/import", fd);
      toast.success(
        `Geri yükleme tamam: ${data.transactions_added} işlem, ${data.recurring_added} sabit işlem eklendi` +
        (data.transactions_skipped ? ` (${data.transactions_skipped} zaten mevcut, atlandı)` : "")
      );
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-6 space-y-4" data-testid="backup-card">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/15 flex items-center justify-center">
          <DatabaseBackup className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h2 className="font-heading text-lg font-semibold">Veri Yedekleme</h2>
          <p className="text-xs text-muted-foreground">Tüm işlemler, sabit işlemler ve bütçe ayarları tek dosyada</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-3">
        <Button data-testid="backup-export-button" variant="outline" onClick={exportBackup} disabled={exporting}
          className="rounded-full border-border hover:bg-secondary">
          {exporting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />}
          Yedeği İndir (JSON)
        </Button>
        <input ref={fileRef} type="file" accept="application/json,.json" className="hidden"
          onChange={importBackup} data-testid="backup-import-input" />
        {canImport && (
        <Button data-testid="backup-import-button" variant="outline" onClick={() => fileRef.current?.click()} disabled={importing}
          className="rounded-full border-border hover:bg-secondary">
          {importing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
          Yedekten Geri Yükle
        </Button>
        )}
      </div>
      <p className="text-xs text-muted-foreground">
        Geri yükleme mevcut verilerinizi silmez; yedekteki kayıtlar eklenir, zaten var olanlar atlanır.
      </p>
    </div>
  );
}
